module.exports = __webpack_public_path__ + "static/media/close-palette.1f07672e.svg";